// import { useEffect, useState } from 'react';
// import { Outlet } from 'react-router-dom';

// // material-ui
// import { useTheme } from '@mui/material/styles';
// import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// // project-imports
// import Drawer from './Drawer';
// import Header from './Header';
// import Footer from './Footer';
// import HorizontalBar from './Drawer/HorizontalBar';
// import Breadcrumbs from 'components/@extended/Breadcrumbs';

// import navigation from 'menu-items';
// import useConfig from 'hooks/useConfig';
// import { dispatch, useSelector } from 'store';
// import { openDrawer } from 'store/reducers/menu';

// // types
// import { LAYOUT_CONST } from 'types/config';
// import { DRAWER_WIDTH } from 'config';

// // ==============================|| MAIN LAYOUT ||============================== //

// const MainLayout = () => {
//   const theme = useTheme();
//   const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
//   const downLG = useMediaQuery(theme.breakpoints.down('lg'));

//   const { container, miniDrawer, menuOrientation } = useConfig();

//   const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

//   const { drawerOpen } = useSelector((state) => state.menu);

//   // drawer toggler
//   const [open, setOpen] = useState(!miniDrawer || drawerOpen);
//   const handleDrawerToggle = () => {
//     setOpen(!open);
//     dispatch(openDrawer({ drawerOpen: !open }));
//   };

//   // set media wise responsive drawer
//   useEffect(() => {
//     if (!miniDrawer) {
//       setOpen(!matchDownLG);
//       dispatch(openDrawer({ drawerOpen: !matchDownLG }));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [matchDownLG]);

//   useEffect(() => {
//     if (open !== drawerOpen) setOpen(drawerOpen);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [drawerOpen]);

//   return (
//     <Box sx={{ display: 'flex', width: '100%' }}>
//       <Header open={open} handleDrawerToggle={handleDrawerToggle} />
//       {!isHorizontal ? <Drawer open={open} handleDrawerToggle={handleDrawerToggle} /> : <HorizontalBar />}

//       <Box component="main" sx={{ width: `calc(100% - ${DRAWER_WIDTH}px)`, flexGrow: 1, p: { xs: 2, sm: 3 } }}>
//         <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
//         <Container
//           maxWidth={container ? 'xl' : false}
//           sx={{
//             ...(container && { px: { xs: 0, sm: 2 } }),
//             position: 'relative',
//             minHeight: 'calc(100vh - 110px)',
//             display: 'flex',
//             flexDirection: 'column'
//           }}
//         >
//           <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />
//           <Outlet />
//           <Footer />
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default MainLayout;

import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// project-imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import HorizontalBar from './Drawer/HorizontalBar';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import navigation from 'menu-items';     // <-- function now
import useConfig from 'hooks/useConfig';
import { dispatch, useSelector } from 'store';
import { openDrawer } from 'store/reducers/menu';

// types
import { LAYOUT_CONST } from 'types/config';
import { DRAWER_WIDTH } from 'config';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { container, miniDrawer, menuOrientation } = useConfig();
  const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

  const { drawerOpen } = useSelector((state) => state.menu);

  // Get navigation items (IMPORTANT FIX)
  const navItems = navigation();                // <-- FIX #1

  const [open, setOpen] = useState(!miniDrawer || drawerOpen);

  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      setOpen(!matchDownLG);
      dispatch(openDrawer({ drawerOpen: !matchDownLG }));
    }
    // eslint-disable-next-line
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line
  }, [drawerOpen]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />

      {!isHorizontal ? (
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
      ) : (
        <HorizontalBar />
      )}

      <Box
        component="main"
        sx={{ width: `calc(100% - ${DRAWER_WIDTH}px)`, flexGrow: 1, p: { xs: 2, sm: 3 } }}
      >
        <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />

        <Container
          maxWidth={container ? 'xl' : false}
          sx={{
            ...(container && { px: { xs: 0, sm: 2 } }),
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* FIX #2 → Pass navItems */}
          <Breadcrumbs
            navigation={navItems}
            title
            titleBottom
            card={false}
            divider={false}
          />

          <Outlet />
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout;
